import { getPointOfSale } from '../utils/get-point-of-sale.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
class BaseEvent {
    /**
     * The base event class that has all the shared functions between Events
     * @param baseEventData - The event data to send
     * @param settings - The global settings
     * @param id - The browser id
     * @param infer - The source of methods to estimate language and page parameters
     */
    constructor(baseEventData, settings, id, infer) {
        var _a, _b, _c;
        this.baseEventData = baseEventData;
        this.settings = settings;
        this.infer = infer;
        this.pointOfSale = getPointOfSale(this.baseEventData.pointOfSale || settings.pointOfSale);
        this.browserId = id;
        this.language = (_a = this.baseEventData.language) !== null && _a !== void 0 ? _a : (_b = this.infer) === null || _b === void 0 ? void 0 : _b.language();
        this.page = (_c = this.baseEventData.page) !== null && _c !== void 0 ? _c : (this.infer ? this.infer.pageName() : '');
    }
    /**
     *  A function that returns the properties for sending events to Sitecore CDP
     * @returns an object that is required
     */
    mapBaseEventPayload() {
        return {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            browser_id: this.browserId,
            channel: this.baseEventData.channel,
            /* eslint-disable @typescript-eslint/naming-convention */
            client_key: this.settings.clientKey,
            currency: this.baseEventData.currency,
            language: this.language,
            page: this.page,
            pos: this.pointOfSale,
        };
    }
}

export { BaseEvent };
